@use "stylesheets/utility/variables";

.dataList {
  margin-bottom: 0;

  &.gapXxs {
    .dataRow + .dataRow {
      margin-top: 5px;
    }
  }
  &.gapXs {
    .dataRow + .dataRow {
      margin-top: 10px;
    }
  }
  &.gapSm {
    .dataRow + .dataRow {
      margin-top: 15px;
    }
  }
  &.gapMd {
    .dataRow + .dataRow {
      margin-top: 20px;
    }
  }
  &.gapLg {
    .dataRow + .dataRow {
      margin-top: 40px;
    }
  }
}

.dataRow {
  &.flex {
    display: flex;
    flex-wrap: wrap;
  }

  &.noWrap {
    flex-wrap: nowrap;
  }

  &.flexColumn {
    flex-direction: column;
  }

  &.mobileFlexColumn {
    @media (max-width: variables.$laptop) {
      display: flex;
      flex-direction: column;
    }
  }

  &.spaceBetween {
    justify-content: space-between;
  }

  .dataTerm,
  .dataDefinition {
    width: auto;
    overflow: hidden;
    overflow-x: auto;
  }

  .dataTerm {
    font-weight: bold;
    flex-shrink: 0;
    padding-right: 5px;
  }

  &.inline {
    .dataTerm,
    .dataDefinition {
      display: inline;
    }
  }
}
